export const USER_ROLES = {
  ADMIN: 'admin',
  TEACHER: 'teacher',
  STUDENT: 'student',
}

export const STARTPAGE_BLOCK_TYPES = {
  NEW_BOOKS: 'new_books',
  NEW_SECTIONS: 'new_sections',
  FEATURED_BOOK: 'featured_book',
  FEATURED_SECTION: 'featured_section',
  FEATURED_BOOKS_GROUP: 'featured_books_group',
  FEATURED_SECTIONS_GROUP: 'featured_sections_group',
}

export const PANEL_TRANSITION_TYPES = {
  FROM_LEFT: 'from_left',
  FROM_RIGHT: 'from_right',
  FROM_BOTTOM: 'from_bottom',
  FADE: 'fade',
}

export const PANEL_LAYOUT_TYPES = {
  PANEL: 'panel',
  MODAL: 'modal',
}

export const PANELS = {
  CREATE_BOOK: 'create_book',
  EDIT_BOOK: 'edit_book',
  CREATE_SECTION: 'create_section',
  EDIT_SECTION: 'edit_section',
  VIEW_SECTION: 'view_section',
  VIEW_BOOK: 'view_book',
  VIEW_SUBJECT_AREA: 'view_subject_area',
  ADD_SECTION_TO_BOOK: 'add_section_to_book',
  TEACHERS_GUIDE: 'teachers_panel',
  ADD_SCHOOL_CLASS: 'add_school_class',
  CREATE_SCHOOL_GROUP: 'create_school_group',
  EDIT_SCHOOL_GROUP: 'edit_school_group',
  ADD_STUDENT_TO_SCHOOL_CLASS: 'add_student_to_school_class',
  ADD_STUDENT_TO_SCHOOL_GROUP: 'add_student_to_school_group',
  ADD_STUDENT_TO_DEMO_SCHOOL_GROUP: 'add_student_to_demo_school_group',
  REMOVE_SCHOOL_CLASS: 'remove_school_class',
  SHARE_BOOK: 'share_book',
  EDIT_EXERCISE: 'edit_exercise',
  CREATE_STUDENT: 'create_student',
  MANAGE_STUDENTS: 'manage_students',
  FEEDBACK: 'feedback',
  SEARCH: 'search',
  USER_AGREEMENT: 'user_agreement',
  MIGRATE_MY_SCHOOL_CLASS: 'migrate_my_school_class',
  DELETE_MY_SCHOOL_CLASS: 'delete_my_school_class',
  HANDLE_STUDENT_PASSWORD: 'handle_student_password',
  REGISTER_STUDENTS: 'register_students',
  CREATE_EXAM: 'create_exam',
  EDIT_EXAM: 'edit_exam',
  INSPECT_PROGRESS: 'inspect_progress',
}

export const POPUPS = {
  DISCOVER_LIBRARY: 'discover_library',
  CREATE_STUDENTS: 'create_students',
  SHARE_BOOK: 'share_book',
  CREATE_GROUP: 'create_group',
  SHARE_BOOK_WITH_GROUP: 'share_book_with_group',
  CREATE_BOOK: 'create_book',
  TIP_COLLEAGUE: 'tip_colleague',
}

export const CONTENT_TYPES = {
  BOOK: 'book',
  SECTION: 'section',
}

export const SCHOOL_RESOURCE_TYPES = {
  GROUP: 'group',
  CLASS: 'class',
  DEMO_GROUP: 'demo_group',
  DEMO_CLASS: 'demo_class',
}

export const BOOK_LIST_TYPES = {
  DOKLET: 'doklet',
  SHARED: 'shared',
  USER_CREATED: 'user_created',
  LIBRARY: 'library',
}

export const CARD_SIZES = {
  SMALL: 'small',
  LARGE: 'large',
}

export const IMAGE_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xlarge',
}

export const COLORS = {
  PRIMARY_GREEN: {
    TEXT: 'text-primaryGreen',
    BACKGROUND: 'bg-primaryGreen',
    ACTIVE: 'bg-primaryGreenDarker',
    HOVER: 'hover:bg-primaryGreenDark',
    BORDER: 'border-primaryGreen',
  },
  SECONDARY_GREEN: {
    TEXT: 'text-secondaryGreen',
    BACKGROUND: 'bg-secondaryGreen',
    ACTIVE: 'bg-secondaryGreenDark',
    HOVER: 'hover:bg-secondaryGreenDark',
    BORDER: 'border-secondaryGreen',
  },
  TRANSPARENT: {
    TEXT: 'text-transparent',
    BACKGROUND: 'bg-transparent',
    BORDER: 'border-transparent',
  },
  BLACK: {
    TEXT: 'text-black',
    BACKGROUND: 'bg-black',
    BORDER: 'border-black',
  },
  LIGHT_BLACK: {
    TEXT: 'text-lightBlack',
    BACKGROUND: 'bg-lightBlack',
    BORDER: 'border-lightBlack',
  },
  OVERLAY_BLACK: {
    TEXT: 'text-overlayBlack',
    BACKGROUND: 'bg-overlayBlack',
    BORDER: 'border-overlayBlack',
  },
  WHITE: {
    TEXT: 'text-white',
    BACKGROUND: 'bg-white',
    BORDER: 'border-white',
  },
  LIGHT_LIGHT_GREY: {
    TEXT: 'text-lightLightGrey',
    BACKGROUND: 'bg-lightLightGrey',
    BORDER: 'border-lightLightGrey',
  },
  LIGHT_GREY: {
    TEXT: 'text-lightGrey',
    BACKGROUND: 'bg-lightGrey',
    BORDER: 'border-lightGrey',
  },
  MEDIUM_GREY: {
    TEXT: 'text-mediumGrey',
    BACKGROUND: 'bg-mediumGrey',
    BORDER: 'border-mediumGrey',
  },
  LIGHT_DARK_GREY: {
    TEXT: 'text-lightDarkGrey',
    BACKGROUND: 'bg-lightDarkGrey',
    BORDER: 'border-lightDarkGrey',
  },
  MEDIUM_DARK_GREY: {
    TEXT: 'text-mediumDarkGrey',
    BACKGROUND: 'bg-mediumDarkGrey',
    BORDER: 'border-mediumDarkGrey',
  },
  DARK_GREY: {
    TEXT: 'text-darkGrey',
    BACKGROUND: 'bg-darkGrey',
    BORDER: 'border-darkGrey',
  },
  DARK_DARK_GREY: {
    TEXT: 'text-darkDarkGrey',
    BACKGROUND: 'bg-darkDarkGrey',
    BORDER: 'border-darkDarkGrey',
  },
  LIGHT_RED: {
    TEXT: 'text-lightRed',
    BACKGROUND: 'bg-lightRed',
    BORDER: 'border-lightRed',
    ACTIVE: 'bg-lightRed',
    HOVER: 'bg-lightRed',
  },
  CANDY_RED: {
    TEXT: 'text-candyRed',
    BACKGROUND: 'bg-candyRed',
    BORDER: 'border-candyRed',
    ACTIVE: 'bg-candyRed',
    HOVER: 'bg-candyRed',
  },
  ALERT_RED: {
    TEXT: 'text-alertRed',
    BACKGROUND: 'bg-alertRed',
    BORDER: 'border-alertRed',
  },
  ALERT_RED_DARK: {
    TEXT: 'text-alertRedDark',
    BACKGROUND: 'bg-alertRedDark',
    BORDER: 'border-alertRedDark',
  },
  ALERT_GREEN: {
    TEXT: 'text-alertGreen',
    BACKGROUND: 'bg-alertGreen',
    BORDER: 'border-alertGreen',
  },
  DEMO_GREEN: {
    TEXT: 'text-demoGreen',
    BACKGROUND: 'bg-demoGreen',
    BORDER: 'border-demoGreen',
  },
  DARK_DEMO_GREEN: {
    TEXT: 'text-darkDemoGreen',
    BACKGROUND: 'bg-darkDemoGreen',
    BORDER: 'border-darkDemoGreen',
  },
}

export const AVATAR_SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
}

export const DIVIDER_SIZE = {
  LINE: 'line',
  XXSMALL: 'xxSmall',
  XSMALL: 'xSmall',
  SMALL: 'small',
  BASE: 'base',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xLarge',
}

export const SECTION_SPACING = {
  XSMALL: 'xSmall',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xLarge',
}

export const CONTAINER_STYLE = {
  DESKTOP: 'desktop',
}

export const BUTTON_SIZE = {
  NOSIZE: 'noSize',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  ICON_ONLY: 'iconOnly',
  ICON_CIRCLE: 'iconCircle',
  NO_PADDING: 'noPadding',
}

// @TODO define button types. Consult with Forss
export const BUTTON_TYPE = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  PRIMARY_OUTLINE: 'primaryOutline',
  SECONDARY_OUTLINE: 'secondaryOutline',
  WHITE_OUTLINE: 'whiteOutline',
  SUBJECT: 'subject',
  DARK_GREY: 'darkGrey',
  DARK_DARK_GREY: 'darkDarkGrey',
  MEDIUM_DARK_GREY: 'mediumDarkGrey',
  ALERT_RED_DARK: 'alertRedDark',
  CANDY_RED: 'candyRed',
}

export const HEADING_TYPE = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
}

export const TEXT_SIZES = {
  XXXSMALL: 'text-xxxSmall',
  XXSMALL: 'text-xxSmall',
  XSMALL: 'text-xxxSmall xl:text-xSmall',
  SMALL: 'text-xxxSmall xl:text-small',
  BASE: 'text-xxxSmall sm:text-xxSmall md:text-xSmall lg:text-small  xl:text-base',
  MEDIUM:
    'text-xxSmall sm:text-xSmall md:text-small lg:text-base xl:text-medium',
  LARGE: 'text-xSmall sm:text-small md:text-base lg:text-medium xl:text-large',
  XLARGE: 'text-small sm:text-base md:text-medium lg:text-large xl:text-xLarge',
  XXLARGE:
    'text-base sm:text-medium md:text-large lg:text-xLarge xl:text-xxLarge',
  XXXLARGE:
    'text-medium sm:text-large md:text-xlarge lg:text-xxLarge xl:text-xxxLarge',
}

export const TEXT_ALIGN = {
  LEFT: 'text-left',
  CENTER: 'text-center',
  RIGHT: 'text-right',
}

export const LABELS = {
  EDIT_BOOK: 'Redigera bok',
  EDIT_SECTIONS: 'Sortera avsnitt',
}

export const CUSTOMER_ACTIONS = {
  DAILY_VISIT: 'Daily Visit',
  VISITED_LIBRARY: 'Visited Library',
  VISITED_HELP: 'Visited Help',
  CLOSED_HELP_TOOLTIP: 'Closed Help Tooltip',
}

export const EXAM_TYPES = {
  QUIZ: { label: 'Quiz', value: '1' },
  SELF_APPROVAL: { label: 'Självrättande', value: '2' },
}

// Number of days a student has to wait before retrying a quiz exam after
// a finished or abandoned attempt. 0 disables the wait entirely.
// Set to 1 to restore the old "try again tomorrow" behaviour.
export const EXAM_RETRY_WAIT_DAYS = 0

export const EXAM_QUESTION_ORDER_TYPES = {
  SEQUENTIAL: { label: 'Angiven', value: '1' },
  RANDOM: { label: 'Slumpad', value: '2' },
}

export const EXAM_DISPLAY_TYPES = {
  PANEL: { label: 'Panel', value: '1' },
  FULL_SCREEN: { label: 'Fullskärm', value: '2' },
}

export const STUDENT_PROGRESS_STATUS = {
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  PASSED: 'passed',
  FAILED: 'failed',
}
